export const keys = { escape: 27 }

export function isKey({ keyCode }, keyName) {
  return keyCode === keys[keyName]
}



// WEBPACK FOOTER //
// ./resources/js/app/events/keyCodes.js